import { createSelector } from 'reselect';

const substate = (state) => state.policies;

export const selectQuery = () => createSelector(substate, (contextState) => contextState.query);
